﻿import { Col } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import { useNavigate } from "react-router-dom";
import { useInitialDataImplementation } from "@/hooks/implementation/firstLoad/initialDataImplementation";

import { validDate } from "@/services/dates.services";

import classes from "./loadinventory.module.scss";

const UnitLoadButtons = ({ data, setUnitaryLoadSelected, mutate }) => {
	const navigate = useNavigate();
	const { addToast } = useToasts();
	const { data: response } = useInitialDataImplementation();

	const handleSave = () => {
		if (!data.business_id) {
			addToast("Debe ingresar la razón social.", {
				appearance: "error",
			});
			return;
		}
		if (!data.estate_id) {
			addToast("Debe seleccionar el campo.", {
				appearance: "error",
			});
			return;
		}
		if (!data.type_currency_id) {
			addToast("Debe seleccionar la moneda.", {
				appearance: "error",
			});
			return;
		}
		if (!data.items.length > 0) {
			addToast("Debe ingresar al menos un producto.", {
				appearance: "error",
			});
			return;
		} else {
			let isValid = true;
			data.items.forEach((item, index) => {
				const lineNumber = index + 1;
				if (!item.product_id) {
					addToast(`Línea ${lineNumber}: Debe seleccionar un producto.`, {
						appearance: "error",
					});
					isValid = false;
					return;
				}
				if (!item.container_content) {
					addToast(`Línea ${lineNumber}: Debe ingresar el contenido por envase.`, {
						appearance: "error",
					});
					isValid = false;
					return;
				}
				if (!item.container_quantity) {
					addToast(`Línea ${lineNumber}: Debe ingresar la cantidad de envases.`, {
						appearance: "error",
					});
					isValid = false;
					return;
				}
				if (!item.unit_measurement) {
					addToast(`Línea ${lineNumber}: Debe seleccionar la unidad de medida.`, {
						appearance: "error",
					});
					isValid = false;
					return;
				}
				if (item.expiration_date && !validDate(item.expiration_date)) {
					addToast(`Línea ${lineNumber}: La fecha de expiración debe ser menor a 01-01-3000.`, {
						appearance: "error",
					});
					isValid = false;
					return;
				}
				if (item.expiration_date && new Date(item.expiration_date).toISOString().startsWith("1900-01-01")) {
					addToast(
						`Línea ${lineNumber}: La fecha 01-01-1900 indica un error en la fecha ingresada. Por favor, verifica la fecha de expiración e intenta de nuevo.`,
						{
							appearance: "error",
						},
					);
					isValid = false;
					return;
				}
			});
			if (!isValid) {
				return;
			}
		}

		const updatedData = {
			...data,
			is_implementation_completed: true,
		};

		mutate(updatedData, {
			onSuccess: () => {
				addToast("Carga de productos realizada correctamente", {
					appearance: "success",
				});
				navigate("/inventario");
			},
		});

		return updatedData;
	};

	return (
		<>
			{response?.isComplete ? (
				<Col md={12} className={classes.col_base}>
					<Col className={classes.buttons} md={12} xs={12}>
						<div className={classes.rightButtons}>
							<div className={classes.buttonClose}>
								<div onClick={() => setUnitaryLoadSelected(false)}>Cerrar</div>
							</div>
							{data && (
								<div className={classes.buttonSave}>
									<div onClick={() => handleSave()}>Finalizar</div>
								</div>
							)}
						</div>
					</Col>
				</Col>
			) : (
				<></>
			)}
		</>
	);
};

export default UnitLoadButtons;
